import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import PropTypes from "prop-types";
import { getCandidateFilter } from "data/selectors/entityFields";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";
import Control
    from "lib/common/descriptorcontrols/AssociationField/recordbrowser";
import SuperRecordListStore from "data/SuperRecordListStore";
import { getSuperRecordListRecords } from "data/SuperRecordListActions";
import React from "react";
import useFluxStore from "@armus/use-flux-store";
import { recordIdType } from "data/util/typedefs";

export class AssociationFieldrecordbrowser extends BaseFormItem {

    constructor(...args) {
        super(...args);
        this.buildOptions = this.buildOptions.bind(this);
        this.onRecordbrowserClick = this.onRecordbrowserClick.bind(this);
    }

    getCandidateFilter() {
        const {activeRecord, descriptor} = this.props;
        return getCandidateFilter(
            entityFieldMetaStore.getInfo(
                activeRecord.entityKey,
                descriptor.key,
            ),
            activeRecord,
        );
    }

    buildOptions(currId, allRecords, enabled) {
        const {descriptor} = this.props;
        const options = [];
        const candidateFilter = this.getCandidateFilter();
        for (const record of allRecords) {
            // unwrap and check candidacy
            if (record.id === currId || record.isRecordEnabled()) {
                if (record.id === currId || candidateFilter(record)) {
                    options.push({
                        name: record.id,
                        display: record.getLabel(),
                        record,
                    });
                }
            }
        }

        // autoSelectOnlyOption only option. Only when the field is enabled.
        if(enabled && descriptor.config.autoSelectOnlyOption && options.length === 1 && currId === null) {
            // Because this may be invoked during component construction, it
            // can't do a synchronous dispatch without violating React's rules
            // about state changes. At least for the moment. Once we don't have
            // all the synchronous backbone-based flows, it can probably vanish.
            //
            // eslint-disable-next-line no-settimeout
            setTimeout(() =>
                    this.onCommitChange(descriptor, options[0].record.id));
        }
        return options;
    };

    onRecordbrowserClick(e) {
        const { onGlobalRecordLookup, descriptor } = this.props;
        e.stopPropagation();
        onGlobalRecordLookup(
            descriptor.config.otherEntityKey,
            descriptor.key,
            this.getCandidateFilter());
    }

    onCommitChange(d, v) {
        super.onCommitChange(d, v === null ? null : parseInt(v));
    }

    render() {
        const {activeRecord, descriptor} = this.props;
        const value = activeRecord.get(descriptor.key);
        const id = value == null ? null : value.id;
        return <ConnCtrl {...this.getPlumbingProps()}
                         valueKey="name"
                         labelKey="display"
                         isLoading={true}
                         onRecordbrowserClick={this.onRecordbrowserClick}
                         value={id}
                         enabled={activeRecord.isFieldEnabled(descriptor.key)}
                         // for the data connection
                         otherEntityKey={descriptor.config.otherEntityKey}
                         builder={this.buildOptions}
        />;
    }

}

const ConnCtrl = (props) => {
    const {otherEntityKey, value, builder, enabled} = props;
    const state = useFluxStore(() => {
        const lo = getSuperRecordListRecords(otherEntityKey);
        return {
            isLoading: lo.isLoading(),
            isError: lo.hasError(),
            allRecords: lo.hasValue() ? lo.getValue() || [] : [],
        };
    }, [
        SuperRecordListStore,
    ], [otherEntityKey]);
    return <Control
        {...props}
        {...state}
        options={builder(value, state.allRecords, enabled)}
    />;
};

ConnCtrl.propTypes = {
    otherEntityKey: PropTypes.string.isRequired,
    enabled: PropTypes.bool,
    value: recordIdType,
    builder: PropTypes.func.isRequired,
};

AssociationFieldrecordbrowser.propTypes = {
    ...AssociationFieldrecordbrowser.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes({
        otherEntityKey: PropTypes.string.isRequired,
        autoSelectOnlyOption: PropTypes.bool,
        showRecordBrowserIcon: PropTypes.bool
    })),
};

export default AssociationFieldrecordbrowser;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/AssociationField/recordbrowser.js